export const payoutRoutes = {
	payoutIndex: '/payouts',
	payoutEdit: (id?: number | string) => `/payouts/${id ?? ':id'}`,
	payoutHistory: (id?: string) => `/payouts/${id ?? ':id'}/history`
} as const
